let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jkPqm"), load("9wxKg"), load("3Ccf1"), load("6cVEd")]).then(() => parcelRequire('bSBwg'));